<template>
    <Link v-bind="attrs">
        <div>{{ $t('form.add') }}</div>
        <PlusCircleIcon class="h-5 w-5" />
    </Link>
</template>

<script setup>
import { useAttrs } from 'vue'
import Link from '@/components/buttons/Link.vue'
import { PlusCircleIcon } from '@heroicons/vue/24/outline'

// Accessing undeclared attributes
const attrs = useAttrs()

// Set inheritAttrs to false to prevent attributes being automatically added to the root element
defineOptions({
    inheritAttrs: false,
})
</script>
